module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3znUuOcIuQaYAiu4Y8QUuQ-9fe9196a9cf376e6e34ea5c0d6b82608.jpg";